<template>
  <div class="index">
        <div class="header">
            <img src="../../assets/img/template@2x(1).png" style="width: 170px"/>
        </div>

        <div class="row" :style="'minHeight:' + Height + 'px;'">
        <div class="col-6 col-m-9" style="padding-left: 10%;">
            <h1 style="margin:30px 0px;">我们是做什么的?</h1>
            <p class="txt">Scholarcy致力于为科研人员与学者提供智能阅读服务,帮助科研人员与学者在工作的各个阶段减少非必要的文献阅读时间,实现精炼阅读,大幅提升工作阅读效率.</p>
            <p class="txt">Scholarcy通过先进的Robot-Highlighter <span style="font-size:8px;vertical-align:text-bottom;">TM</span> 技术从文档中提取结构化数据并同步翻译成中文并通过知识归纳引擎生成文章概要,精炼地呈现文章.</p>
            <p class="txt">Scholarcy提炼要点全面包括摘要,关键点,概要,简介,研究结果,讨论,相关工作,总结,基金,参与人员与数据统计,参与文献,笔记备注等内容从而大幅节省科研时间,降低跨界阅读门槛,全面梳理研究脉络,适合可重复性研究.</p>
            <el-button class="button" @click="go">前往提炼</el-button>
        </div>

        <div class="col-6 col-m-12" style="padding-right:10%">
            <img src="../../assets/img/introduce.png" style="width:100%;" alt="">
        </div>
        <div style="padding: 0px 10%;" class="list col-12">
            <!-- #F7C154 #EC663D -->
                    <div class="grid-content bg-purple ">
                        <div style="background-color:#F7C154;padding: 15px;width: 60px;border-radius: 10px;"> <img  style="width: 30px;" src="../../assets/img/333.png" alt=""> </div>
                        <div class="title">
                            <p>自动划出文献重点,</p>
                            <p>提高文献阅读效率</p>
                        </div>
                    </div>
                    <div class="grid-content bg-purple ">
                        <div style="background-color:#F7C154;padding: 15px;width: 60px;border-radius: 10px"> <img  style="width: 30px;" src="../../assets/img/111.png" alt=""> </div>
                        <div class="title">
                            <p>快速提取文献精华,</p>
                            <p>保留原文内容不改写</p>
                        </div>
                    </div>
                    <div class="grid-content bg-purple ">
                        <div style="background-color:#EC663D;padding: 15px;width: 60px;border-radius: 10px"> <img  style="width: 30px;" src="../../assets/img/222.png" alt=""> </div>
                        <div class="title">
                            <p>全面理解研究脉络,</p>
                            <p>适合可重复性研究</p>
                        </div>
                    </div>
                    <div class="grid-content bg-purple ">
                        <div style="background-color:#EC663D;padding: 18px;width: 60px;border-radius: 10px"> <img  style="width: 30px;" src="../../assets/img/5.png" alt=""> </div>
                        <div class="title">
                            <p>支持上传多篇文章,</p>
                            <p>降低使用时间成本</p>
                        </div>
                    </div>
        </div>
        <div class="col-12 col-m-12 " style="padding: 0px 10%;margin-top:25px;margin-bottom:30px;">
            <div class="container">
                <div class="img"></div>
                <div class="title-size" style="line-height:25px;">
                    Scholarcy从PDF文件创建摘要卡,并导出 Word ! 其曾于2020年荣获"研习与专业领域出版机构协会 ( ALPSP ) 出版创新奖 ".
                </div>
                <div class="img-left"></div>
            </div>
        </div>
        </div>
        <div class="footer">
           <ul class="left">
                <li>北京盈科千信科技有限公司</li>
                <li>地址： 北京市海淀区中关村南大街48号</li>
                </ul>
                <ul class="right">
                <li>邮箱： product@increscence.net</li>
                <li>
                    Copyright © 2022 <img style="width:20px;margin-bottom: -5px;" src="../../assets/img/footerp.png" alt=""> 京ICP备15054044号-1
                </li>
            </ul>
        </div>
  </div>
</template>

<script>
export default {
    name:"",
    data(){
        return{
            Height: 0, // 主体内容高度
        }
    },
    mounted(){
        this.Height = document.documentElement.clientHeight - 70; //监听浏览器窗口变化

        window.onresize = () => {
            this.Height = document.documentElement.clientHeight - 70;
        };
    },
    methods: {
        go(){
            this.$router.push({
                name: "Login",
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.index{
    // overflow-y: hidden;
    // overflow: scroll;
    // overflow-x: hidden;
    position: relative;
}
// 按钮
.button{
    background-color: #7E51E7;
    color: white;
    border-radius: 10px;
    border:1px solid #7E51E7;
    margin-top:20px;
    padding: 15px 25px;
    font-size: 16px;
}
.title-size{
    text-align:center;
    font-size:15px;
    width:70%;
    margin:0 auto;
    margin-top: 60px;
}
.txt{
    margin:20px 0px;
    line-height:27px;
    font-size: 15px;
}
.list{
    display: flex;
    justify-content: space-between;
    .grid-content{
        width: 24%;
    }
}
// @media (min-width: 499px){
//     .title-size{
//         text-align:center;
//         font-size:8px;
//         line-height: 160px;
//     }
// }
* {
    box-sizing: border-box;
}
.container{
    width: 100%;
    height: 160px;
    border: 1px solid #FAD2C5;
    border-radius: 10px;
    position: relative;
    .img{
        float: right;
        width: 200px;
        height: 80px;
        background: url('../../assets/img/jie.png') no-repeat;
        background-size: 100% 100%;
        
    }
    .img-left{
        float: left;
        width: 200px;
        height: 200px;
        background: url('../../assets/img/7.png') no-repeat -42px 0px;
        background-size: 100% 100%;
        position: absolute;
        top: 60px;
    }
}
.row:after {
    content: "";
    clear: both;
    display: block;
}
[class*="col-"] {
    float: left;
    padding: 15px;
}
html {
    font-family: "Lucida Sans", sans-serif;
}
.header {
    // background-color: #9933cc;
    color: #ffffff;
    padding: 10px 15px 0px 15px;
    border-bottom: 1px solid;
}
.menu ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.menu li {
    padding: 8px;
    margin-bottom: 7px;
    background-color :#33b5e5;
    color: #ffffff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}
.menu li:hover {
    background-color: #0099cc;
}

.aside {
    background-color: #33b5e5;
    padding: 15px;
    color: #ffffff;
    text-align: center;
    font-size: 14px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}
.bg-purple{
    display: flex;
    align-items: center;
    border: 1px solid #8F9EE3;
    border-radius: 10px;
    padding: 30px;
}
.title{
    font-weight: 700;
    line-height: 20px;
    margin-left: 15px;
}
.footer {
    // background-color: #0099cc;
    width:100%;
    color: #ffffff;
    text-align: center;
    font-size: 12px;
    padding-bottom: 15px;
    // padding: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    // position: absolute;
    // bottom: 0px;
    // left: 0px;
    // right: 0px;
    margin: auto;
    .left {
            width: 250px;
            margin-right: 30px;
            text-align: left;
            color: #b0b0b0;
            list-style: none;
            line-height: 20px;
        }
        .right{
            text-align: left;
            border-left: 2px solid #b0b0b0;
            padding-left: 30px;
            color: #b0b0b0;
            line-height: 20px;
            list-style: none;
        }
}
/* For mobile phones: */
[class*="col-"] {
    // width: 100%;
}

@media only screen and (min-width: 600px) {
    /* For tablets: */
    .col-m-12 {width: 8.33%;}
    .col-m-2 {width: 16.66%;}
    .col-m-3 {width: 25%;}
    .col-m-4 {width: 33.33%;}
    .col-m-5 {width: 41.66%;}
    .col-m-6 {width: 50%;}
    .col-m-7 {width: 58.33%;}
    .col-m-8 {width: 66.66%;}
    .col-m-9 {width: 75%;}
    .col-m-10 {width: 83.33%;}
    .col-m-11 {width: 91.66%;}
    .col-m-12 {width: 100%;}
}
@media only screen and (min-width: 768px) {
    /* For desktop: */
    .col-1 {width: 8.33%;}
    .col-2 {width: 16.66%;}
    .col-3 {width: 25%;}
    .col-4 {width: 33.33%;}
    .col-5 {width: 41.66%;}
    .col-6 {width: 50%;}
    .col-7 {width: 58.33%;}
    .col-8 {width: 66.66%;}
    .col-9 {width: 75%;}
    .col-10 {width: 83.33%;}
    .col-11 {width: 91.66%;}
    .col-12 {width: 100%;}
}
</style>